import React, { useState, useEffect } from "react";

const Loader = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Disable scrolling during loading
    document.body.style.overflow = isLoading ? "hidden" : "auto";

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto"; // Re-enable scrolling
    };
  }, [isLoading]);

  return (
    <>
      {isLoading && (
        <div style={styles.loaderContainer} className="loader-animation">
          <div style={styles.spinner}></div>
          <p style={styles.text}>Loading...</p>
        </div>
      )}
      {!isLoading && (
        <div className="content-animation">{children}</div>
      )}
    </>
  );
};

const styles = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#f9f9f9",
    zIndex: 9999,
    transition: "opacity 0.5s ease-in-out",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid #ccc",
    borderTop: "5px solid #313265",
    borderRadius: "50%",
    animation: "spin 0.5s linear infinite",
  },
  text: {
    marginTop: "10px",
    fontSize: "18px",
    color: "#555",
  },
};

export default Loader;
